<template>
  <form @submit.prevent="onSubmit">
    <div class="comment-form-1-is-login" v-if="isLogin">
      <m-rate1 class="" v-model="form.rate"/>
      <form-errors-manager :validation="v$.form.rate"/>

      <textarea placeholder="....." class="form-control" v-model="form.body"/>
      <form-errors-manager :validation="v$.form.body"/>

      <div class="text-center">
        <button class="btn rounded-pill px-4 my-2 btn-primary" type="submit"
                v-t="`comment.form.submit_button`"></button>
      </div>

    </div>
    <div class="comment-form-1-not-login " v-else>
      <m-a :href="{name:'Login'}" class="d-inline-block">
        <p class="comment-form-1-not-login-link" v-t="`comment.form.login_message`"/>
      </m-a>
    </div>
  </form>
</template>

<script>
import {useVuelidate} from "@vuelidate/core";
import {required, maxLength} from '@vuelidate/validators'
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import mRate1 from "../Rate/Rate1.vue";
import {commentProps} from "../CommentProps";
import {mapGetters} from "vuex";
import mA from '../../Tags/A';

export default {
  name: "CommentForm1",
  components: {mRate1, FormErrorsManager, mA},
  props: {
    ...commentProps
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      form: {
        body: {required},
        rate: {required},
      },
    }
  },
  data() {
    return {
      form: {
        body: '',
        parent_id: null,
        commentable_type: '',
        commentable_id: '',
        rate: '',
      }
    }
  },
  computed: {
    ...mapGetters({
      isLogin: 'User/isAuthenticated'
    })
  },
  methods: {
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return

      let cloneForm = Object.assign({}, this.form)
      if (cloneForm.parent_id == null) {
        delete cloneForm.parent_id
      }
      cloneForm.commentable_id = this.commentable_id
      cloneForm.commentable_type = this.commentable_type

      this.$store.dispatch("Comment/createComment", cloneForm)

    },
  },
}
</script>

<style scoped>

</style>